module.exports = __webpack_public_path__ + "src/img/artist/artist07.jpg?25942d14a233d723c4dbc5a09846d169";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artist07.jpg
// module id = 114
// module chunks = 0